import "./cameras.css";
import { checkStatus } from "ultils/helper";

const SignalStatus = (props) => {
	const { item } = props;

	return <div className='parkings-row'>{checkStatus(item)}</div>;
};
export default SignalStatus;
